// extracted by mini-css-extract-plugin
module.exports = {"h1":"ErrorDisplay_h1__1lH8Z","h2":"ErrorDisplay_h2__dovCa","p":"ErrorDisplay_p__soLCB"};